import { createContext, useContext } from "react";

/** Surface of the open drawer, so nested dialogs can portal into it and center there. */
export const DrawerSurfaceContext = createContext<HTMLElement | null>(null);

export function useDrawerSurface(): HTMLElement | null {
  return useContext(DrawerSurfaceContext);
}

/**
 * Front-most left/right drawer in the DOM. Used when a dialog is a sibling of
 * the drawer in React (not a descendant) so it can still center in the panel.
 */
export function getFrontDrawerSurface(): HTMLElement | null {
  if (typeof document === "undefined") return null;
  const nodes = document.querySelectorAll<HTMLElement>(
    '[data-slot="sheet-content"][data-side="right"], [data-slot="sheet-content"][data-side="left"]',
  );
  let front: HTMLElement | null = null;
  for (const node of nodes) {
    if (node.getAttribute("data-drawer-covered-by") !== "0") continue;
    if (getComputedStyle(node).display === "none") continue;
    front = node;
  }
  return front;
}
